import clsx from "clsx";
import { useIsDocsAndExtractActive } from "core/model/careseekers";
import { ControlledCheckbox } from "ds/ui";
import { useIsEligiblePage } from "dsl/ecosystems/PatientFiles/useUploadFile";
import { useTranslations } from "translations";

export function getFileExtension(filename: string): string {
  const lastDotIndex = filename.lastIndexOf(".");
  if (lastDotIndex < 0) return "";
  return filename.slice(lastDotIndex);
}

export function getFileStem(filename: string): string {
  const lastDotIndex = filename.lastIndexOf(".");
  if (lastDotIndex < 0) return filename;
  return filename.slice(0, lastDotIndex);
}

export const ExtractBanner = () => {
  const translations = useTranslations();
  const { isDischargeLetterActive, isDocsAndExtractActive } =
    useIsDocsAndExtractActive();
  const isEligiblePage = useIsEligiblePage();
  const showExtractCheckbox =
    (isDocsAndExtractActive || isDischargeLetterActive) && !isEligiblePage;

  return (
    <div
      className={clsx("flex flex-col gap-5 rounded-md bg-primary-light p-4", {
        hidden: !showExtractCheckbox,
      })}
    >
      <div className="flex flex-col gap-1">
        <h3 className="text-heading-md font-bold">
          {translations.extractDocs.fileUploadModal.extractBannerTitle}
        </h3>
        <p className="text-body-md">
          {translations.extractDocs.fileUploadModal.extractBannerDescription}
        </p>
      </div>
      <ControlledCheckbox
        label={translations.extractDocs.fileUploadModal.extractBannerCheckbox}
        name="should_extract_on_upload"
      />
    </div>
  );
};
